import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    fontSize: designTokens.fontSize.xs,
    lineHeight: designTokens.lineHeight.normal,
    "& .fui-Checkbox__label": {
      color: designTokens.neutral[800],
      padding: 0,
    },
    "& .fui-Checkbox": {
      padding: 0,
    },
  },
});
